import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickAriaProps, pickComponentCommonProps } from '../../interfaces/commonProps';
import { StyledBadgeContainer, StyledBadgeCount } from './Badge.styles';
export var Badge = forwardRef(function Badge(_ref, ref) {
  var count = _ref.count,
      ariaLabel = _ref['aria-label'],
      role = _ref.role,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'informative' : _ref$variant,
      restProps = _objectWithoutProperties(_ref, ["count", "aria-label", "role", "variant"]);

  var outerSpacing = useSpacing(restProps);
  var commonProps = pickComponentCommonProps(restProps);
  var ariaProps = pickAriaProps(restProps);
  return React.createElement(StyledBadgeContainer, _objectSpread({
    ref: ref,
    role: role || count ? 'status' : undefined,
    "aria-label": ariaLabel,
    displayCount: Boolean(count),
    variant: count ? 'informative' : variant,
    outerSpacing: outerSpacing
  }, commonProps, {}, ariaProps), count !== undefined && count > 0 && React.createElement(StyledBadgeCount, {
    count: count
  }, count > 99 ? '99+' : count));
});